import IoTriggerConfigSerializer from 'eflex/serializers/io-trigger-config';

export default class TurckIoTriggerConfigSerializer extends IoTriggerConfigSerializer {}
